import React from 'react';
import styles from './AdminUserList.module.scss';
import AdminTableList from '../../../components/admin/AdminTableList/AdminTableList';
import { userList } from '../../../redux/actions/user/userList';
import { Box } from '@mui/material';
import dayjs from 'dayjs';

export function formatPhoneNumber(phoneNumber) {
  const cleaned = phoneNumber?.toString().replace(/\D/g, '');

  if (cleaned?.length !== 10) {
    return phoneNumber;
  }

  const countryCode = '+7';
  const areaCode = cleaned.substring(0, 3);
  const firstPart = cleaned.substring(3, 6);
  const secondPart = cleaned.substring(6, 8);
  const thirdPart = cleaned.substring(8, 10);

  return `${countryCode} (${areaCode}) ${firstPart}-${secondPart}-${thirdPart}`;
}

const AdminUserList = () => {
  const columns = [
    {
      label: 'Аватар',
      onTransform: (val) => <Box component={'img'} src={val?.avatar} sx={{ width: '24px', height: '24px', objectFit: 'cover', borderRadius: '4px', margin: '0 auto' }}></Box>,
    },
    {
      label: 'ФИО',
      onTransform: (val) => `${val?.firstName} ${val?.lastName}`,
    },
    {
      label: 'Пол',
      onTransform: (val) => (val?.isFemale ? 'Женский' : 'Мужской'),
    },
    {
      label: 'Телефон',
      onTransform: (val) => formatPhoneNumber(val?.phone),
    },
    {
      label: 'Страна',
      onTransform: (val) => val?.citizenship?.name ?? '-',
    },
    {
      label: 'Город',
      onTransform: (val) => val?.city?.name ?? '-',
    },
    {
      label: 'Дата рождения',
      onTransform: (val) => (val?.birthDate ? dayjs(val?.birthDate).format('DD.MM.YYYY') : '-'),
    },
    {
      label: 'Уровень игры',
      onTransform: (val) => val?.grade?.name ?? '-',
    },
    {
      label: 'Домашний клуб',
      onTransform: (val) => val?.club?.name ?? '-',
    },
  ];
  return (
    <div>
      <AdminTableList title={'Пользователи'} sliceName={'user'} actionName={'userList'} fetch={userList} pathEdit="/admin/user/edit" columns={columns} textEmpty={'Пользователей нет'} />
    </div>
  );
};

export default AdminUserList;
